import { getROIMeasurement } from '../../../../modules/dicom-measurement/src';

/**
 * @param {Object[]} instances[].points
 * @param {String} instances[].ReferencedSOPInstanceUID
 * @param {Number[]} instances[].PixelSpacing
 * @param {Number[]} instances[].ImagePositionPatient
 * @param {Number[]} instances[].ImageOrientationPatient
 * @param {Number} instances[].SliceThickness
 * @param {Number} instances[].InstanceNumber
 * @param {String} roi.ROIName
 * @param {Number} roi.ROINumber
 */
function getLesion(instances, roi) {
  const measurement = getROIMeasurement(instances, roi);
  return { ...measurement, volume: measurement.volume / 1000 };
}

/**
 * @param {Object[]} serie.instances
 * @param {Object[]} ROIContours
 * @param {Object[]} ROIContours[].data
 */
function getLesions(series, ROIContours) {
  const { instances } = series;
  instances.sort((a, b) => Number(a.InstanceNumber) - Number(b.InstanceNumber));
  const Lesions = [];
  ROIContours.forEach(roi => {
    Lesions.push(getLesion(instances, roi));
  });
  return Lesions;
}

export default getLesions;
